export class ApiDetail {
  apiDefinition: string;
  authorizationHeader: string;
  context: string;
  createdTime: string;
  description: string;
  endpointURLs: string[];
  environmentList: string[];
  id: string;
  isDefaultVersion: boolean;
  labels: string[];
  lastUpdatedTime: string;
  name: string;
  provider: string;
  status: string;
  tags: string[];
  thumbnailUri: string;
  tiers: string[];
  transport: string[];
  version: string;
  wsdlUri: string;

}
